var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCaseStudiesGraphic = function SvgCaseStudiesGraphic(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 750,
    viewBox: "0 0 449 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4904 708L204.722 42H391.51L244.301 708H57.4904Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.481 669L234.296 81H342.519L214.724 669H106.481Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.482 617L258.787 133L295.518 133L190.23 617L153.482 617Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49211 748L167.927 2H446.508L281.098 748H2.49211Z",
    stroke: "#1D2131",
    strokeWidth: 4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCaseStudiesGraphic);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQ5IiBoZWlnaHQ9Ijc1MCIgdmlld0JveD0iMCAwIDQ0OSA3NTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01Ny40OTA0IDcwOEwyMDQuNzIyIDQySDM5MS41MUwyNDQuMzAxIDcwOEg1Ny40OTA0WiIgc3Ryb2tlPSIjMUQyMTMxIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTEwNi40ODEgNjY5TDIzNC4yOTYgODFIMzQyLjUxOUwyMTQuNzI0IDY2OUgxMDYuNDgxWiIgc3Ryb2tlPSIjMUQyMTMxIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTE1My40ODIgNjE3TDI1OC43ODcgMTMzTDI5NS41MTggMTMzTDE5MC4yMyA2MTdMMTUzLjQ4MiA2MTdaIiBzdHJva2U9IiMxRDIxMzEiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMi40OTIxMSA3NDhMMTY3LjkyNyAySDQ0Ni41MDhMMjgxLjA5OCA3NDhIMi40OTIxMVoiIHN0cm9rZT0iIzFEMjEzMSIgc3Ryb2tlLXdpZHRoPSI0Ii8+Cjwvc3ZnPgo=";